/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */

export const SupportApiEnum = {
    GET_TICKETS_ALL: (): string => {
        return '/support/tickets/';
    },
    POST_TICKET_CREATE: (): string => {
        return '/support/tickets/';
    },
    GET_TICKET: (id: any): string => {
        return `/support/tickets/${id}`;
    },
    PUT_TICKET_UPDATE: (id: any): string => {
        return `/support/tickets/${id}`;
    },
    DELETE_TICKET: (id: any): string => {
        return `/support/tickets/${id}`;
    },
    GET_TICKET_COMMENTS: (id: any, cursor?: any): string => {
        return `/support/tickets/${id}/comments/${cursor ? '?' + cursor : ''}`;
    },
    POST_TICKET_COMMENTS: (id: any): string => {
        return `/support/tickets/${id}/comments/`;
    }
};
